const THOUSAND = 1_000
const TEN_THOUSAND = 10_000
const LAKH = 100_000
const MILLION = 1_000_000

const trimTrailingZeros = (value: string): string => value.replace(/\.00$/, '').replace(/(\.\d*[1-9])0$/, '$1')

const formatScaled = (value: number, divisor: number, suffix: string): string => {
    const scaled = value / divisor
    const rounded = Math.round((scaled + Number.EPSILON) * 100) / 100
    return `${trimTrailingZeros(rounded.toFixed(2))}${suffix}`
}

/** Gold-coin stake label: abbreviate 5+ digit values as 10K / 1L / 1M (GoldNumberFont). */
export const formatCoinDisplayValue = (value: number): string => {
    const normalized = Math.round((value + Number.EPSILON) * 100) / 100

    if (!Number.isFinite(normalized) || normalized <= 0) {
        return ''
    }

    if (normalized >= MILLION) {
        return formatScaled(normalized, MILLION, 'M')
    }

    if (normalized >= LAKH) {
        return formatScaled(normalized, LAKH, 'L')
    }

    if (normalized >= TEN_THOUSAND) {
        return formatScaled(normalized, THOUSAND, 'K')
    }

    return trimTrailingZeros(normalized.toFixed(2))
}
